import React, { useEffect, useRef } from 'react';
import useIsInViewport from '../hooks/useIsInViewport';

interface IPageContentEndProps {
  onIsVisibleChange: (isVisible: boolean | undefined) => void;
}

export const PageContentEnd: React.FC<IPageContentEndProps> = ({ onIsVisibleChange }) => {
  const anchor = useRef<HTMLDivElement | null>(null);
  const isVisible = useIsInViewport(anchor, true);

  useEffect(() => {
    onIsVisibleChange(isVisible);
  }, [isVisible]);

  return <div ref={anchor} />;
};
